/** Lorebook search must observe privacy withdrawals on the next request. */
export default function createUncachedLorebookSearchConfig(configuration) {
    return {
        ...configuration,
        server: {
            ...configuration.server,
            useServerSideSearchCache: false,
            cacheSearchResultsForSeconds: 0,
        },
    };
}
